<template lang="pug">
#img-container.img-container
    img(v-if="imgurl" :src="imgurl" alt="Image")
    div.error(v-else-if="error") Unable to load image: {{ error }}
    div.loading(v-else) Loading...
</template>
<script setup lang="ts">
import { useDocuments } from '@/store/useDocuments';
import { onMounted, ref, watch } from 'vue';

const documents = useDocuments();

type Props = {
    imgRef: string
}
const props = defineProps<Props>();

const imgurl = ref<string | null>(null);
const error = ref<string | null>(null);

watch(() => props.imgRef, async r => {
    try {
        const url = await documents.getUrl(r);
        if(!url) throw new Error("Can't find image");
        imgurl.value = url;
    } catch(e) {
        console.error(e);
        error.value = (e as Error).message;
    }
}, { immediate: true })
</script>
<style lang="scss">
#img-container.img-container{
    display: grid;
    position: relative;
    overflow: hidden;
    justify-content: center;
    align-content: center;
    border-radius: $border-radius-8;
    &, img, div{
        max-height: 10rem;
        max-width:  10rem;
        width:      10rem;
        height:     10rem;
        border: 1px solid $color-black;
    }
    img{
        object-fit:cover;
        object-position: center center;
        position: relative;
        width:  auto;
        height: auto;
    }
    div{
        border-style: dashed;
    }
    div.error{
        border-color:$color-red;
    }
}
</style>